// Isolated starter integration: keep SVG validation private to this asset.
(() => {
  var MAX_LOGO_BYTES = 2 * 1024 * 1024;
  function validateLogoSvg(source) {
    if (new TextEncoder().encode(source).length > MAX_LOGO_BYTES) throw new Error("Choose an SVG smaller than 2 MB.");
    if (/<!DOCTYPE|<!ENTITY/i.test(source)) throw new Error("Export a plain SVG without external resources.");
    const parsed = new DOMParser().parseFromString(source, "image/svg+xml");
    if (parsed.querySelector("parsererror") || parsed.documentElement.localName !== "svg") throw new Error("Choose a valid SVG logo.");
    const allowed = /* @__PURE__ */ new Set(["svg", "g", "path", "rect", "circle", "ellipse", "line", "polyline", "polygon", "defs", "clipPath", "mask", "linearGradient", "radialGradient", "stop", "title", "desc", "use", "symbol", "text", "tspan", "style"]);
    const elements = [...parsed.querySelectorAll("*")];
    if (elements.length > 5e3) throw new Error("Simplify this SVG before adding it.");
    const safeCss = (value) => !/[@\\]|expression\s*\(/i.test(value) && [...value.matchAll(/url\s*\(([^)]*)\)/gi)].every((match) => /^['"]?#[\w.-]+['"]?$/.test(match[1].trim()));
    for (const element of elements) {
      if (!allowed.has(element.localName)) throw new Error("Use a vector SVG with paths and no embedded images or active content.");
      for (const attribute of [...element.attributes]) {
        if (/^on/i.test(attribute.localName) || attribute.localName === "base" || attribute.localName === "href" && !/^#[\w.-]+$/.test(attribute.value) || !safeCss(attribute.value)) {
          throw new Error("Export an SVG without scripts or external links.");
        }
      }
      if (element.localName === "style" && !safeCss(element.textContent || "")) throw new Error("Export an SVG without external styles.");
    }
    return new XMLSerializer().serializeToString(parsed.documentElement);
  }



(() => {
  'use strict';
  if (!['/products/custom-gameday-mvp-flagpole-kit', '/products/custom-gameday-flag'].includes(location.pathname)) return;
  const prefix = '#gameday-start=';
  if (!location.hash.startsWith(prefix) || location.hash.length > 1600) return;
  const params = new URLSearchParams(location.hash.slice(prefix.length));
  if (!['1', '2'].includes(params.get('v')) || !/^#[0-9a-f]{6}$/i.test(params.get('primary') || '') || !/^#[0-9a-f]{6}$/i.test(params.get('secondary') || '')) return;
  const cleanText = (value, length) => String(value || '').replace(/[\u0000-\u001f\u007f]/g, ' ').slice(0, length);
  const artwork = params.get('v') === '2' ? params.get('artwork') : 'none';
  if (!['gameday-mark', 'jolly-roger', 'none', 'upload'].includes(artwork)) return;
  const pirate = artwork === 'jolly-roger' && params.get('mode') === 'pirate';
  const start = { name: cleanText(params.get('name'), 60), front: cleanText(params.get('front'), 36), back: cleanText(params.get('back'), 36), primary: params.get('primary'), secondary: params.get('secondary') };
  const root = document.querySelector('[data-gameday-custom-designer]');
  if (!root || root.dataset.gamedayFrontdoorApplied) return;
  const status = root.querySelector('[data-custom-sales-status]');
  const origins = ['https://gamedayflags.com', 'https://www.gamedayflags.com', 'https://exo-brand-frontdoors-web.aread.workers.dev'];
  const source = params.get('source');
  const nonce = params.get('handoff') || '';
  const sender = window.opener;
  let logoPending = artwork === 'upload' && origins.includes(source) && /^[0-9a-f-]{36}$/i.test(nonce) && Boolean(sender);
  let channelTimer;
  let interacted = false;
  let applying = false;
  let attempts = 0;
  let finished = false;
  const onInput = event => { if (event.isTrusted && !applying) interacted = true; };
  root.addEventListener('input', onInput, true);
  const update = (field, value) => {
    field.value = value;
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  };
  const closeChannel = () => {
    logoPending = false;
    window.clearTimeout(channelTimer);
    window.removeEventListener('message', receive);
    root.removeEventListener('input', onInput, true);
    try { window.opener = null; } catch { /* The browser may already have detached it. */ }
  };
  const reply = type => sender?.postMessage({ type, nonce }, source);
  const importLogo = data => {
    if (!logoPending) return;
    try {
      const svg = validateLogoSvg(data.svg);
      let name = cleanText(data.name, 120).replace(/[\\/]/g, '-') || 'my-gameday-logo.svg';
      if (!/\.svg$/i.test(name)) name += '.svg';
      const inputs = ['front', 'back'].map(side => root.querySelector(`[data-custom-upload="${side}"]`));
      if (inputs.some(input => !input)) throw new Error('Designer upload fields unavailable');
      applying = true;
      const upload = root.querySelector('[data-custom-stock-upload]');
      if (upload && upload.getAttribute('aria-pressed') !== 'true') upload.click();
      for (const input of inputs) {
        const transfer = new DataTransfer();
        transfer.items.add(new File([svg], name, { type: 'image/svg+xml' }));
        input.files = transfer.files;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        if (input.files.length !== 1) throw new Error('Logo file could not be assigned');
      }
      applying = false;
      if (status) status.textContent = 'Your logo, words, and colors are here on both sides. Refine the placement and review your proof before checkout.';
      reply('gameday-logo-applied'); closeChannel();
    } catch {
      applying = false;
      if (status) status.textContent = 'Your words and colors are here. Choose the same SVG in the logo fields to finish importing your artwork.';
      reply('gameday-logo-error'); closeChannel();
    }
  };
  function receive(event) {
    if (!logoPending || !finished || event.origin !== source || event.source !== sender || event.data?.type !== 'gameday-logo-file' || event.data?.nonce !== nonce) return;
    const data = event.data;
    if (typeof data.svg !== 'string' || data.svg.length > MAX_LOGO_BYTES || typeof data.name !== 'string') {
      reply('gameday-logo-error'); closeChannel(); return;
    }
    if (interacted || ['front', 'back'].some(side => root.querySelector(`[data-custom-upload="${side}"]`)?.files.length)) {
      if (!status) return;
      status.textContent = 'Your Gameday logo is ready. Apply it when you are ready to replace the artwork on both sides. ';
      const button = document.createElement('button'); button.type = 'button'; button.textContent = 'Apply my Gameday logo';
      button.addEventListener('click', () => importLogo(data), { once: true }); status.appendChild(button);
    } else importLogo(data);
  }
  const apply = () => {
    const fields = {
      name: root.querySelector('[data-custom-name]'), front: root.querySelector('[data-custom-text-input="front"]'), back: root.querySelector('[data-custom-text-input="back"]'),
      primary: root.querySelector('[data-custom-brand-hex="primary"]'), secondary: root.querySelector('[data-custom-brand-hex="secondary"]'),
      apply: root.querySelector('[data-custom-brand-apply]'), color: root.querySelector('[data-custom-color="front-background"]'),
    };
    const stock = root.querySelector(`[data-custom-stock-design][data-stock-design-id="${artwork === 'jolly-roger' ? 'jolly-roger' : 'gameday-mark'}"]`);
    if (root.dataset.customReady !== 'true' || !fields.color?.options.length || !Object.values(fields).every(Boolean) || (['gameday-mark', 'jolly-roger'].includes(artwork) && (!stock || stock.disabled))) return false;
    applying = true;
    if (pirate) {
      root.dataset.pirateMode = 'true';
      // Keep the native proof/cart fields, but never place lettering on a pirate preset.
      const lettering = [fields.front, fields.back, root.querySelector('[data-custom-header-text]')].filter(Boolean);
      lettering.forEach(field => { field.readOnly = true; update(field, ''); });
      const keepUnlettered = event => { if (lettering.includes(event.target)) event.target.value = ''; };
      root.addEventListener('input', keepUnlettered, true);
      root.addEventListener('change', keepUnlettered, true);
      const size = root.querySelector('[data-custom-size="3x5"]');
      if (size && size.getAttribute('aria-pressed') !== 'true') size.click();
      if (root.dataset.customKit === 'true') {
        const mount = root.querySelector('[data-custom-kit-mount]');
        if (mount && !mount.disabled) {
          mount.checked = params.get('mount') === 'surface';
          mount.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      root.querySelectorAll('[data-custom-placement]').forEach(field => {
        if (field.dataset.customPlacement === 'logo-scale') update(field, field.max || '100');
        if (['logo-x', 'logo-y'].includes(field.dataset.customPlacement)) update(field, '0');
      });
      const identity = root.querySelector('.custom-designer__step--identity');
      if (identity) {
        const intro = document.createElement('div'); intro.className = 'gameday-pirate-intro';
        const heading = document.createElement('h3'); heading.textContent = 'PIRATE THIS FLAG';
        const copy = document.createElement('p'); copy.textContent = 'Your colors. Our Jolly Roger. Full-size artwork on both faces, with no lettering.';
        intro.append(heading, copy); identity.before(intro);
      }
    }
    update(fields.name, start.name || (pirate ? 'My Pirate Flag' : 'My Gameday kit')); update(fields.front, pirate ? '' : start.front); update(fields.back, pirate ? '' : start.back);
    update(fields.primary, start.primary); update(fields.secondary, start.secondary); fields.apply.click();
    if (['gameday-mark', 'jolly-roger'].includes(artwork)) stock.click();
    else { const upload = root.querySelector('[data-custom-stock-upload]'); if (upload && upload.getAttribute('aria-pressed') !== 'true') upload.click(); }
    root.dataset.gamedayFrontdoorApplied = 'true'; finished = true; applying = false;
    // Keep a pirate starter reloadable and shareable. Other handoffs retain their existing behavior.
    if (!pirate) history.replaceState(history.state, '', `${location.pathname}${location.search}#gameday-custom-designer`);
    if (status) status.textContent = pirate ? 'Your pirate flag is ready in these colors. Review both sides and choose your size before checkout.' : logoPending ? 'Your words and colors are here. Receiving your logo from Gameday…' : artwork === 'upload' ? 'Your words and colors are here. Add the same SVG in the logo fields to finish your preview.' : 'Your Gameday starter is here. Refine both sides and review your proof before checkout.';
    root.scrollIntoView({ behavior: 'auto', block: 'start' });
    if (logoPending) {
      window.addEventListener('message', receive);
      reply('gameday-logo-ready');
      channelTimer = window.setTimeout(() => {
        if (status) status.textContent = 'Your words and colors are here. If your logo has not arrived, choose the same SVG in the logo fields.';
        reply('gameday-logo-error'); closeChannel();
      }, 60000);
    } else root.removeEventListener('input', onInput, true);
    return true;
  };
  const offer = () => {
    if (!status || finished) return;
    status.textContent = 'Your Gameday starter is ready to apply when you are. ';
    const button = document.createElement('button'); button.type = 'button'; button.textContent = 'Apply my starter';
    button.addEventListener('click', () => { if (!apply()) button.textContent = 'Designer loading — try again'; }); status.appendChild(button);
  };
  const wait = () => {
    if (finished) return;
    if (interacted) { offer(); return; }
    if (apply()) return;
    if (++attempts >= 120) { offer(); return; }
    window.setTimeout(wait, 100);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wait, { once: true }); else wait();
})();

})();
